import { ListInternationalDataOutput } from '../mycicero-web-api/shared/list-international-data-output.model'

export interface InternationalData {
  country: string
  countryCode: string
}

export const mapListInternationalDataOutput = (output: ListInternationalDataOutput): InternationalData[] =>
  output.Prefixes.map((v) => ({
    country: v.Country,
    countryCode: `+${v.CountryCode}`,
  }))
